import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import EventScope from 'owa-service/lib/contract/EventScope';
import getCalendarEventOperation from 'owa-service/lib/operation/getCalendarEventOperation';
import getCalendarEventRequest from 'owa-service/lib/factory/getCalendarEventRequest';
import itemId from 'owa-service/lib/factory/itemId';
import ItemId from 'owa-service/lib/contract/ItemId';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import recurringMasterItemId from 'owa-service/lib/factory/recurringMasterItemId';
import { CalendarEvent } from 'mini-calendar-event-types';
import { calendarEvent } from 'mini-calendar-event-converter';
import { ClientItemId } from 'owa-client-ids';
import { GetDetailedCalendarEventOptions } from '../schema/GetDetailedCalendarEventOptions';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getMailboxRequestOptions from 'owa-service-utils/lib/getMailboxRequestOptions';
import { createRequestQueue, RequestQueue } from 'owa-service-utils';
const MAXIMUM_NUM_REQUESTS = 6;
let requestQueue: RequestQueue = null;

/**
 * Makes the GetCalendarEvent call to the server to get the calendar event object
 * @param id id of the calendar event that needs to be fetched
 * @param shape shape of the calendar event object that will be returned
 * @param options Additional options while making the get detailed event api call
 * @param eventScope flag which says whether we want series master or series instance
 */
export const getCalendarEventService = async (
    calendarEventId: ClientItemId,
    shape: ItemResponseShape,
    options: GetDetailedCalendarEventOptions,
    eventScope: EventScope = EventScope.Default,
    seriesMasterId: ItemId = undefined
): Promise<CalendarEvent> => {
    const { Id: id, mailboxInfo } = calendarEventId;
    const fetchMasterItem =
        eventScope === EventScope.AllInstancesInSeries ||
        eventScope === EventScope.ThisAndFollowingInstances;
    if (!requestQueue) {
        requestQueue = createRequestQueue(MAXIMUM_NUM_REQUESTS);
    }
    const response = await requestQueue.add(() =>
        getCalendarEventOperation(
            {
                Header: getJsonRequestHeader(),
                Body: getCalendarEventRequest({
                    EventIds: [
                        fetchMasterItem
                            ? seriesMasterId
                                ? itemId({ Id: seriesMasterId.Id })
                                : recurringMasterItemId({ OccurrenceId: id })
                            : itemId({ Id: id }),
                    ],
                    ItemShape: shape,
                    IncludeDeclinedMeetings: options.IncludeDeclinedMeetings,
                }),
            },
            getMailboxRequestOptions(mailboxInfo)
        )
    );
    const responseMessage = response.Body.ResponseMessages.Items[0] as ItemInfoResponseMessage;
    if (responseMessage != null && responseMessage.ResponseClass === 'Success') {
        const calendarItem = responseMessage.Items[0] as CalendarItem;
        if (calendarItem != null) {
            return calendarEvent(calendarItem, calendarEventId.mailboxInfo);
        }
    }

    // In case of error, we are ignoring it
    return null;
};
